export const hasTodoCustomFields = () => {
	return (
		Tools.FeatureHelper.isAvailable(Tools.FeatureHelper.Feature.ACTIVITY_CUSTOM) && // This is so we only show it for customers that have access to activity custom fields (did not make a new type for these as both todos and phonecalls are under the Activity feature)
		Tools.FeatureHelper.hasSoftDeployAccess('TODO_LIST') && // If they event have todos
		Tools.FeatureHelper.hasSoftDeployAccess('REMOVE_ACTIVITIES') // This is so we do not show them for customers that still uses old activities
	);
};
